import styled from 'styled-components';
import {
  Input,
} from 'antd';
import {
  COLOR_CV_5,
  COLOR_NEUTRAL_5,
} from 'constants/colors';

export const StyledAntdInput = styled(Input)`
  &:hover,
  &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: ${COLOR_CV_5};
  }

  &.ant-input-affix-wrapper-disabled:hover {
    border-color: ${COLOR_NEUTRAL_5};
  }

  &:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }
`;

export const StyledAntdTextArea = styled(Input.TextArea)`
  &:hover {
    border-color: ${COLOR_CV_5};
  }

  &:focus {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }
`;
